import React from 'react';
import { ShieldCheckIcon, MailIcon, LockKeyholeIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-5" data-id="element-43">
      <div className="flex items-center gap-1.5 text-mutedBrown" data-id="element-44">
        <ShieldCheckIcon className="w-4 h-4 text-[#8B2252]" data-id="element-45" />
        <span className="text-xs font-medium" data-id="element-46">
          Garantía de Satisfacción 7 Días
        </span>
      </div>
      <div className="flex items-center gap-1.5 text-mutedBrown" data-id="element-47">
        <MailIcon className="w-4 h-4 text-[#8B2252]" data-id="element-48" />
        <span className="text-xs font-medium" data-id="element-49">
          Descarga Inmediata a tu correo
        </span>
      </div>
      <div className="flex items-center gap-1.5 text-mutedBrown" data-id="element-50">
        <LockKeyholeIcon className="w-4 h-4 text-[#8B2252]" data-id="element-51" />
        <span className="text-xs font-medium" data-id="element-52">Pago seguro en tu compra</span>
      </div>
    </div>;
}